import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface ConditionListPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class ConditionListPage extends Component<ConditionListPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.condition.list }}
                pages={{
                    entity: InferenceEntities.condition(this.props),
                    list: {}
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}